import React, { useState } from "react";
import { api } from "./api";

// Edit the note, change the label or undo it. Labels are append-only on the server: an edit or undo is
// recorded as a new row and audited (old -> new). Changing a label to "malicious" asks twice, as in Review.
export default function ReviewEditControls({ verdict, styles, onChanged }) {
  const [note, setNote] = useState(verdict.note || "");
  const [label, setLabel] = useState(verdict.label);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  if (verdict.state && verdict.state !== "active") {
    return <span style={{ fontSize: 12, color: "var(--hs-text-muted)" }} data-testid="review-not-editable">{verdict.state === "withdrawn" ? "undone" : "edited (see newer label)"}</span>;
  }
  const id = verdict.verdict_id || verdict.id;
  const save = async () => {
    const body = {};
    if (label !== verdict.label) body.label = label;
    if (note !== (verdict.note || "")) body.note = note;
    if (!Object.keys(body).length) { setMsg("Nothing changed."); return; }
    if (body.label === "malicious") {
      if (!window.confirm("Change this label to MALICIOUS? Confirmed items become public.")) return;
      if (!window.confirm("Are you sure? This is the malicious label.")) return;
      body.confirm_malicious = true;
    }
    setBusy(true);
    try { const r = await api.editReview(id, body); setMsg(`Saved — tier is now ${r.data.tier}.`); onChanged && onChanged(); }
    catch (ex) { setMsg("Error: " + ex.message); } finally { setBusy(false); }
  };
  const undo = async () => {
    if (!window.confirm("Undo this label? The item goes back to the rules / model assessment.")) return;
    setBusy(true);
    try { const r = await api.undoReview(id); setMsg(`Undone — tier is now ${r.data.tier}.`); onChanged && onChanged(); }
    catch (ex) { setMsg("Error: " + ex.message); } finally { setBusy(false); }
  };
  return (
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }} data-testid={`review-edit-${id}`}>
      <label className="hs-label" htmlFor={`rv-label-${id}`} style={{ marginBottom: 0 }}>Label</label>
      <select id={`rv-label-${id}`} data-testid="review-edit-label" style={styles.select} value={label} onChange={(e) => setLabel(e.target.value)}>
        <option value="benign">benign</option><option value="unsure">unsure</option><option value="malicious">malicious</option>
      </select>
      <label className="hs-label" htmlFor={`rv-note-${id}`} style={{ marginBottom: 0 }}>Note</label>
      <input id={`rv-note-${id}`} data-testid="review-edit-note" style={{ ...styles.input, minWidth: 220, flex: 1 }} value={note} onChange={(e) => setNote(e.target.value)} />
      <button type="button" data-testid="review-edit-save" style={styles.btnDim} disabled={busy} onClick={save}>Save</button>
      <button type="button" data-testid="review-edit-undo" style={styles.btnDim} disabled={busy} onClick={undo}>Undo label</button>
      {msg && <span style={{ fontSize: 12, color: "var(--hs-text-muted)" }} data-testid="review-edit-msg">{msg}</span>}
    </div>
  );
}
